function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "14",
  viewBox: "0 0 35 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M34.468 7.59a1.257 1.257 0 00-.875-.34H4.786l4.938-4.938A1.248 1.248 0 009.723.518a1.25 1.25 0 00-1.767.026L1.014 7.487a1.27 1.27 0 00-.289.288L0 8.5l.722.722c.08.112.18.21.292.292l6.942 6.942c.315.325.777.453 1.214.337.437-.112.779-.454.891-.89.116-.438-.012-.9-.337-1.215L4.786 9.75h28.807c.515.007.983-.302 1.178-.78a1.255 1.255 0 00-.303-1.38z",
  fill: "#000"
})));